import React from 'react';
import { writeStorage } from '@rehooks/local-storage';
import { makeStyles } from '@material-ui/core/styles';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import Button, { ButtonProps } from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { useIntl, FormattedMessage } from 'react-intl';

const useStyles = makeStyles(theme => ({
  extendedIcon: {
    marginLeft: theme.spacing(1)
  }
}));

const LocaleButton: React.FC<ButtonProps> = ({ ...props }) => {
  const intl = useIntl();
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );
  const classes = useStyles();

  function handleClick(event: React.MouseEvent<HTMLButtonElement>) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  function handleClickLocale(locale: 'ko' | 'en') {
    writeStorage('locale', locale);
    setAnchorEl(null);
  }

  return (
    <>
      <Button
        aria-controls="locale-menu"
        aria-haspopup="true"
        onClick={handleClick}
        variant="outlined"
        {...props}
      >
        <FormattedMessage id="LocaleButton.language" defaultMessage="한국어" />
        <KeyboardArrowDownIcon className={classes.extendedIcon} />
      </Button>
      <Menu
        id="locale-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          selected={intl.locale === 'ko'}
          onClick={() => handleClickLocale('ko')}
        >
          한국어
        </MenuItem>
        <MenuItem
          selected={intl.locale === 'en'}
          onClick={() => handleClickLocale('en')}
        >
          English
        </MenuItem>
      </Menu>
    </>
  );
};

export default LocaleButton;
